export default __webpack_public_path__ + "static/media/variant_logo.579769fb.png";